import React, { useEffect, useState } from 'react';
import { Alert, Button, InputNumber, Modal, Table, Typography } from 'antd';
import {
  PAYMENT_CHANNELS, countConfiguredFees, formatFeeText, pullMerchantFees,
} from '../../../../utils/paymentChannels';

const { Text } = Typography;

// 支付方式手续费弹窗（仅用于扣减抽佣基数）
const PaymentFeeModal = ({ open, value, pullable, onChange, onClose }) => {
  const [draft, setDraft] = useState({});

  useEffect(() => {
    if (open) setDraft({ ...(value || {}) });
  }, [open, value]);

  const update = (channel, field, v) => {
    setDraft((prev) => {
      const cur = { ...(prev[channel] || {}) };
      if (v == null || v === '') delete cur[field];
      else cur[field] = v;
      const next = { ...prev };
      if (Object.keys(cur).length === 0) delete next[channel];
      else next[channel] = cur;
      return next;
    });
  };

  return (
    <Modal
      title="支付方式手续费"
      open={open}
      onCancel={onClose}
      width={760}
      destroyOnClose
      centered
      maskClosable={false}
      styles={{ body: { maxHeight: 'calc(100vh - 240px)', overflowY: 'auto', overscrollBehavior: 'contain' } }}
      footer={[
        pullable
          ? <Button key="pull" onClick={() => { setDraft(pullMerchantFees()); }}>重新从平台商户号带出</Button>
          : null,
        <Button key="cancel" onClick={onClose}>取消</Button>,
        <Button key="ok" type="primary" onClick={() => { onChange(draft); onClose(); }}>确定</Button>,
      ].filter(Boolean)}
    >
      <Alert
        type="info" showIcon style={{ marginBottom: 12 }}
        message="手续费仅在抽取佣金时扣减抽佣基数，不产生独立扣款"
        description="抽佣基数 = 订单实付金额 − 底价扣减额 − 支付手续费；手续费 = 订单实付 × 费率 + 固定费用（按订单币种取 CNY 或 USD）。留空表示未配置，按 0 参与计算。"
      />
      <Table
        dataSource={PAYMENT_CHANNELS}
        rowKey="value"
        size="small"
        pagination={false}
        columns={[
          { title: '支付方式', dataIndex: 'label', width: 140 },
          {
            title: '手续费比例', key: 'rate', width: 160,
            render: (_, r) => (
              <InputNumber min={0} max={100} precision={2} style={{ width: 130 }} addonAfter="%"
                placeholder="未配置" value={draft[r.value]?.rate}
                onChange={(v) => update(r.value, 'rate', v)} />
            ),
          },
          {
            title: '固定费用 CNY', key: 'fixedFeeCny', width: 180,
            render: (_, r) => (
              <InputNumber min={0} precision={2} style={{ width: 150 }} addonBefore="¥"
                placeholder="未配置" value={draft[r.value]?.fixedFeeCny}
                onChange={(v) => update(r.value, 'fixedFeeCny', v)} />
            ),
          },
          {
            title: '固定费用 USD', key: 'fixedFeeUsd', width: 180,
            render: (_, r) => (
              <InputNumber min={0} precision={2} style={{ width: 150 }} addonBefore="$"
                placeholder="未配置" value={draft[r.value]?.fixedFeeUsd}
                onChange={(v) => update(r.value, 'fixedFeeUsd', v)} />
            ),
          },
          {
            title: '状态', key: 'status', width: 90,
            render: (_, r) => (formatFeeText(draft[r.value]) === '未配置'
              ? <Text type="secondary">未配置</Text>
              : <Text style={{ color: '#52c41a' }}>已配置</Text>),
          },
        ]}
      />
      <Text type="secondary" style={{ fontSize: 12, display: 'inline-block', marginTop: 8 }}>
        已配置 {countConfiguredFees(draft)}/{PAYMENT_CHANNELS.length} 个支付方式
      </Text>
    </Modal>
  );
};

export default PaymentFeeModal;
